import type { FC } from "react";
import {
  CoreCarsComponent,
  type CarReservationDetailPageProps,
  useCarReservationDetailPage,
  useCarsStyles,
} from "@apac/components/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { TripsAppPage, PageLoadingScreen } from "@tenant/ui";
import defaultStyles from "./CarReservationDetailPage.module.scss";
import {
  CarReservationCancellation,
  CarReservationDetails,
} from "@/modules/cars-postbooking/components";

export const CarReservationDetailPage: FC<CarReservationDetailPageProps> = ({
  tripsRoute,
}) => {
  const styles = useCarsStyles(
    CoreCarsComponent.CarReservationDetailPage,
    defaultStyles
  );
  const [block] = useModuleBEM(
    styles,
    CoreCarsComponent.CarReservationDetailPage
  );

  const {
    context: {
      isLoading,
      isQuoteLoading,
      isFulfilling,
      itinerary,
      showCancellation,
      cancelFlowStep,
      cancelScenario,
    },
    handlers: {
      onQueryCancellation,
      onExitCancellation,
      handleGroundCancel,
      getPolicyInfo,
    },
  } = useCarReservationDetailPage({ tripsRoute });

  const { t } = useI18nContext();

  const loadingText = isFulfilling
    ? t("selfServe.cancelProcessing")
    : isQuoteLoading
      ? t("selfServe.cancelLoading")
      : t("fetchingTrips");

  return (
    <TripsAppPage className="CarReservationDetailPage" contentClassName={block}>
      {isLoading ? (
        <PageLoadingScreen
          isLoading
          text={loadingText}
          subtitle={
            isQuoteLoading || isFulfilling
              ? t("selfServe.processingSubtitle")
              : null
          }
        />
      ) : (
        itinerary != null &&
        (showCancellation ? (
          <CarReservationCancellation
            itinerary={itinerary}
            cancelFlowStep={cancelFlowStep}
            cancelScenario={cancelScenario}
            onConfirmCancel={handleGroundCancel}
            // Retry re-fetches the quote; it must never confirm the cancellation.
            onRetry={getPolicyInfo}
            onBack={onExitCancellation}
          />
        ) : (
          <CarReservationDetails
            itinerary={itinerary}
            onCancel={onQueryCancellation}
          />
        ))
      )}
    </TripsAppPage>
  );
};
